import { SITE_NAME } from "@/lib/site";

/**
 * Two-tone studio wordmark. The first word of SITE_NAME is the mark ("EWEB",
 * inherits the caller's weight/colour); the rest is a lighter gold descriptor
 * ("Studios"). Single source of truth: derived from SITE_NAME so a brand change
 * only touches lib/site.ts. Sizing/weight of the mark comes from the caller.
 */
const [MARK, ...REST] = SITE_NAME.split(" ");
const DESCRIPTOR = REST.join(" ");

/** The mark alone ("EWEB") — for the oversized decorative footer sign-off. */
export const WORDMARK_MARK = MARK;

export function Wordmark({
  className,
  descriptorClassName = "font-medium text-accent",
}: {
  className?: string;
  /** Styling for the descriptor part; override for the muted footer sign-off. */
  descriptorClassName?: string;
}) {
  return (
    <span className={className}>
      {MARK}
      {DESCRIPTOR ? (
        <span className={`ml-[0.22em] ${descriptorClassName}`}>{DESCRIPTOR}</span>
      ) : null}
    </span>
  );
}
